<snelstart-ui-dialog-definition id="tm" title="{{this.title}}" size="xl" [(visible)]="dialogVisible">
  <snelstart-ui-dialog-body>
    <form [formGroup]="this.inputFg">
      <div>
        <snelstart-ui-textarea-form-control formControlName="value"
                                            class="me-1 custom-input-800"
                                            [rows]="7"
                                            [disabledControl]="readonly"
        >
        </snelstart-ui-textarea-form-control>
      </div>
    </form>
    @if (readonly) {
      <div class="d-flex align-items-center label-with-tooltip">
        <snelstart-ui-button id="customPolicy" class="me-1" type="secondary" (click)="setCustomPolicy()">
          Eigen grondslag gebruiken
        </snelstart-ui-button>
        <snelstart-ui-tooltip-trigger
          [tooltipTriggerConfiguration]="tooltips.customPolicy">
        </snelstart-ui-tooltip-trigger>
      </div>
    }
    @if (!readonly) {
      <div class="d-flex align-items-center label-with-tooltip">
        <snelstart-ui-button id="defaultPolicy" class="me-1" type="secondary" [config]="setDefaultPolicy">
          Standaard grondslag gebruiken
        </snelstart-ui-button>
        <snelstart-ui-tooltip-trigger
          [tooltipTriggerConfiguration]="tooltips.defaultPolicy">
        </snelstart-ui-tooltip-trigger>
      </div>
    }
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button id="cancel" class="me-1" type="secondary" btn-x (click)="cancel()">
      Annuleren
    </snelstart-ui-button>
    <snelstart-ui-button id="save" type="primary" icon="check" (click)="submit()">
      Akkoord
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

